export default {
  smothScroll(element) {
    const queryElement = document.querySelector(element)
    const scroll = () => {
      queryElement.scrollTo({
        top: queryElement.scrollHeight,
        behavior: 'smooth',
      })
    }

    scroll()

    setTimeout(() => {
      scroll()
    }, 10)
  },
}
